import script from "./LoginRedirect.vue?vue&type=script&lang=js"
export * from "./LoginRedirect.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__